module.exports = __webpack_public_path__ + "static/img/media-bar-36px.b34faedb.png";